import React, { useEffect } from 'react';
import {
    TextField,
    Box,
    Grid,
    Typography,
    // 
    Divider, Paper,
} from '@mui/material';

const boxContent = {
    display: 'flex',
    gap: 20,
    alignItems: 'center'
}
const typographyText = {
    textAlign: 'left',
    width: '15%'
}
const CredentialAllotmentItem = (props) => {
    if (props.moduleRelationData && props.moduleRelationData != null) {
        var undefinedArrData = []
        if (props.moduleRelationData.type === "dropdown") {            
            props.moduleRelationData && props.moduleRelationData.options.map((val) => {
                undefinedArrData.push({
                    name: val.value,
                    value: 0
                })
            })
        }
        let NewDropdownArr = (props.dropdownValues == undefined || !Array.isArray(props.dropdownValues)) ? undefinedArrData : props.dropdownValues
        return (
            <Grid item align="center" xs={12} sx={{ pl: 2, pr: 2 }}>
                <Box style={boxContent}>
                    <Typography style={typographyText} variant='subtitle2'> {props.displayName ? props.displayName : ''} </Typography>
                    {(props.moduleRelationData.type === "dropdown") ?
                        NewDropdownArr?.map((data, index) => {
                            return (<Box sx={{ width: '100px' }}>
                                <TextField
                                    label={data.name ? data.name : ''}
                                    size="small"
                                    id="outlined-required"
                                    type="number"
                                    name={data.name}
                                    value={data.value}
                                    onChange={(e) => {
                                        props.onCredChange(index, e)
                                    }}
                                />
                            </Box>)
                        }) : <TextField
                            label={props.displayName ? props.displayName : ''}
                            size="small"
                            id="outlined-required"
                            type="number"
                            value={props.value}
                            onChange={(e) => {
                                props.onChange(e)
                            }}
                        />}
                </Box>
                <Divider sx={{ my: 2 }} orientation="horizontal" />
            </Grid>
        )
    }

}

export default CredentialAllotmentItem;